import React from 'react'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom';

import TemplateInfo from 'components/TemplatePerformance/TemplateInfo';
import ShadowBox from 'components/ShadowBox';
import UsersAnalytics from 'components/TemplatePerformance/UsersAnalytics'; 
import ScreenHeading from 'components/ScreenHeading';
import LeaderBoard from 'components/Analytics/LeaderBoard';
import ScoreDistributionChart from 'components/Analytics/ScoreDistribution';
import { AttemptRateChart } from 'components/Analytics/ScoreDistribution';
import { getAverageAttemptRateDetails } from 'services/analyticsV2';
import { getPersonalizedInterview } from 'services';
import { getLeaderboard } from 'services/analyticsV2';
import { WhiteBox } from 'components/AppShell';

const PersonalizedInterviewPerformance = () => {
    const { id } = useParams();

    const [template, setTemplate] = React.useState({});
    const [leaderboardData, setLeaderboardData] = React.useState({ topPerformers: [], bestPerformers: [] });
    const [leaderboardLoading, setLeaderboardLoading] = React.useState(true);
    const [leaderboardError, setLeaderboardError] = React.useState(null);
    const [leaderboardCategory, setLeaderboardCategory] = React.useState('best_score');
    const [attemptRateData, setAttemptRateData] = React.useState(null);
    const [attemptRateLoading, setAttemptRateLoading] = React.useState(true);
    const [attemptRateError, setAttemptRateError] = React.useState(null);
  
    React.useEffect(() => {
      getPersonalizedInterview({ _id: id })
        .then(({ templates }) => {
          const matchingTemplate = templates.find(template => template._id === id);
          if (matchingTemplate) {
            setTemplate(matchingTemplate); 
          } else {
            console.error(`Template with id ${id} not found`);
          }
        })
        .catch(console.error);
    }, [id]);

    React.useEffect(() => {
      if (!id) return;
      setLeaderboardLoading(true);
      setLeaderboardError(null);
      
      const params = { type: 'interview', id, interviewVariantType: 'verbal_mock' };
      // verbal_mock is one of the variant types that supports leaderboard type
      params.leaderboardType = leaderboardCategory;
      
      getLeaderboard(params)
        .then(response => setLeaderboardData(response || { topPerformers: [], bestPerformers: [] }))
        .catch(err => setLeaderboardError(err.message))
        .finally(() => setLeaderboardLoading(false));
    }, [id, leaderboardCategory]);

    React.useEffect(() => {
      if (!id) return;
      setAttemptRateLoading(true);
      setAttemptRateError(null);
      getAverageAttemptRateDetails({ type: 'interview', id, interviewVariantType: 'verbal_mock' })
        .then(response => setAttemptRateData(response))
        .catch(err => setAttemptRateError(err.message))
        .finally(() => setAttemptRateLoading(false));
    }, [id]);

  return (
    <Box display="flex" flexDirection="column" minHeight='calc(100vh - 76px)' gap={4}>
       <ScreenHeading title="Mock interview analytics" id="mock-analytics"></ScreenHeading>
       <TemplateInfo template={template} interviewType='Next Round Mock' />
       <Box display='flex' gap={4}>
       <WhiteBox sx={{width : '100% !important'}}>
          <LeaderBoard 
            data={leaderboardData} 
            loading={leaderboardLoading} 
            error={leaderboardError}
            leaderboardCategory={leaderboardCategory}
            setLeaderboardCategory={setLeaderboardCategory}
            interviewVariantType="verbal_mock"
          />
      </WhiteBox>
      <Box display='flex' width='100%' flexDirection='column' gap={4}>
          <WhiteBox>
            <ScoreDistributionChart
              avgDistribution={{
                batchAverageScore: Math.round(attemptRateData?.averageScoreStats?.averageScore || 0)
              }}
              scoreDistribution={attemptRateData?.averageScoreStats || {"0-30": 0, "31-60": 0, "61-100": 0}}
              totalStudents={attemptRateData?.totalStudents || 0}
              loading={attemptRateLoading}
              error={attemptRateError}
              interviewVariantType="verbal_mock"
            />
          </WhiteBox>
          <WhiteBox>
            <AttemptRateChart 
                attemptRate={{
                  attemptRate: attemptRateData?.attemptRateStats?.attemptRate || 0,
                  userSubmittedCount: (attemptRateData?.attemptRateStats?.["31-60"] || 0) + (attemptRateData?.attemptRateStats?.["61-100"] || 0),
                  userNotSubmittedCount: attemptRateData?.attemptRateStats?.["0-30"] || 0
                }}
                loading={attemptRateLoading}
                error={attemptRateError}
                totalStudents={attemptRateData?.totalStudents || 0}
            />
          </WhiteBox>
        </Box>
      </Box>
      <ShadowBox sx={{ mt: 0 }}>
        <UsersAnalytics
          batch={template?.batch?._id}
          template={template}
          forTemplateAnalytics={true}
          interviewType="verbal_mock"
        />
      </ShadowBox>
    </Box>
  )
}

export default PersonalizedInterviewPerformance;